import { gql } from '@apollo/client'

export const GET_ARTICLE_BY_ID = gql`
  query GetArticleFront($input: oGetArticleInput) {
    getArticleFront(input: $input) {
      _id
      sContent
      oAdvanceFeature {
        bEditorsPick
        bExclusiveArticle
      }
      sTitle
      oDisplayAuthor {
        sDisplayName
        bIsVerified
      }
      nViewCount
      nDuration
      dPublishDisplayDate
      dPublishDate
      oImg {
        sUrl
        sText
      }
      oCategory {
        _id
      }
      oSeo {
        sSlug
      }
      aSeries {
        eStatus
        sName
        _id
        oSeo {
          sSlug
        }
      }
    }
  }
`

export const GET_RANDOM_ARTICLE = gql`
  query RandomArticles($input: randomArticlesInput) {
    randomArticles(input: $input) {
      _id
      sTitle
      oImg {
        sUrl
        sText
      }
      oSeo {
        sSlug
      }
      sSrtTitle
      nDuration
      dPublishDate
      dPublishDisplayDate
    }
  }
`
export const GET_CATEGORY_NEWS_VIDEOS = gql`
  query ListSimpleCategoryArticlesVideosFront($input: oListSimpleCategoryArticlesVideosFront) {
    listSimpleCategoryArticlesVideosFront(input: $input) {
      oArticles {
        nTotal
        aResults {
          _id
          sTitle
          dPublishDisplayDate
          dPublishDate
          sDescription
          nDuration
          oSeo {
            sSlug
          }
          oCategory {
            _id
          }
          oImg {
            sText
            sUrl
          }
        }
      }
    }
  }
`

export const GET_NEXT_ARTICLE = gql`
  query GetNextArticleFront($input: getNextArticleFrontInput) {
    getNextArticleFront(input: $input) {
      _id
      sContent
      oAdvanceFeature {
        bEditorsPick
        bExclusiveArticle
      }
      sTitle
      oDisplayAuthor {
        sDisplayName
        bIsVerified
      }
      nViewCount
      nDuration
      dPublishDisplayDate
      dPublishDate
      oImg {
        sUrl
        sText
      }
      oCategory {
        _id
      }
      oSeo {
        sSlug
      }
      aSeries {
        eStatus
        sName
        _id
        oSeo {
          sSlug
        }
      }
    }
  }
`
